import type { FigmaRestApi } from "@zeytal/types";

import { getFigmaVersionsEndpoint } from "../endpoints/index.ts";

const publishedFigmaDefaultLabel = /^components published$/i;

const savedFilter = (version: FigmaRestApi.Version) => !!version.label;

const publishedFilter = (version: FigmaRestApi.Version) =>
  publishedFigmaDefaultLabel.test(version.label ?? "");

const handleFileVersionSaved = (versions: FigmaRestApi.Version[]) => {
  const [version] = versions.filter(savedFilter);

  if (!version || !version.id) {
    return null;
  }

  return version.id;
};

const handleFileVersionPublished = (versions: FigmaRestApi.Version[]) => {
  const [version] = versions.filter(publishedFilter);

  if (!version || !version.id) {
    return null;
  }

  return version.id;
};

export const findLatestFileVersion = async (
  figmaApiKey: string,
  fileId: string,
  fileVersionType: string,
) => {
  if (!fileVersionType || fileVersionType === "live") {
    return { id: fileId, version: null };
  } else if (
    fileVersionType !== "live" &&
    fileVersionType !== "saved" &&
    fileVersionType !== "published"
  ) {
    return { id: fileId, version: null };
  }

  const response = await getFigmaVersionsEndpoint(
    figmaApiKey,
    fileId,
    "page_size=100",
  );

  const { versions } = response;

  if (!versions.length) {
    return { id: fileId, version: null };
  }

  if (fileVersionType === "saved") {
    return { id: fileId, version: handleFileVersionSaved(versions) };
  } else if (fileVersionType === "published") {
    return { id: fileId, version: handleFileVersionPublished(versions) };
  }
};
